import React from "react";
import { convertPascalCaseToWords, ILeadActivity, ProposalContentType, ProposalFormatType, ProposalReason } from "../../core";
import { Control, Controller, DeepMap, FieldError } from "react-hook-form";
import { LeadRequirement } from "../../core/api/models/requirement";
import { DropdownList } from "react-widgets";
import ErrorMessage from "../../components/text/ErrorMessage";
import { ContainerLoader } from "../../components/loader";
import ActivityAutoCompleteInput from "../../components/form-group/activity-auto-complete-input";
import api from "../../api";
import moment from "moment";
import { CreateFormProps } from "./props";

interface CreateproposalformitemsProps {
    activity: ILeadActivity;
    control: Control<CreateFormProps>;
    createData: any;
    errors: DeepMap<CreateFormProps, FieldError>;
    isUpdatingActivity: boolean;
    onPressEdit: (act: ILeadActivity) => Promise<void>;
    reasons: ProposalReason[];
    requirementData: LeadRequirement;
    setValue: (name: string, value: unknown, config?: Partial<{
        shouldValidate: boolean;
        shouldDirty: boolean;
    }> | undefined) => void
    watch: any

}

export function CreateProposalFormItems({ activity,
    control,
    createData,
    errors,
    isUpdatingActivity,
    onPressEdit,
    reasons,
    requirementData,
    setValue,
    watch }: CreateproposalformitemsProps) {
    return (
        <div className="pt-4 mt-3">
            <div className="col-5 px-0">
                <div className="row gutter-8">
                    <div className="form-group font-weight-semibold mb-3 pb-1 col-md-6 col-12">
                        <label htmlFor="" className="font-md">
                            Proposal Format Type<span className="text-danger">*</span>
                        </label>
                        <Controller
                            control={control}
                            name="proposalFormatType"
                            rules={{ required: "Format Type is required" }}
                            defaultValue={createData?.proposalFormatType}
                            render={({ onChange, value, name }) => (
                                <DropdownList
                                    data={Object.keys(ProposalFormatType).map((key) => {
                                        return {
                                            label: convertPascalCaseToWords(key),
                                            value: key,
                                        };
                                    })}
                                    textField={"label"}
                                    valueField={"value"}
                                    placeholder="Format Type"
                                    onChange={(val) => onChange(val.value)}
                                    name={name}
                                    value={value}
                                />
                            )}
                        ></Controller>
                        <ErrorMessage>{errors.proposalFormatType?.message}</ErrorMessage>
                    </div>
                    <div className="form-group font-weight-semibold mb-3 pb-1 col-md-6 col-12">
                        <label htmlFor="" className="font-md">
                            Proposal Type<span className="text-danger">*</span>
                        </label>
                        <Controller
                            control={control}
                            name="proposalContentType"
                            rules={{ required: "Proposal Type is required" }}
                            defaultValue={createData?.proposalContentType}
                            render={({ onChange, value, name }) => (
                                <DropdownList
                                    data={Object.keys(ProposalContentType).filter(item => ProposalContentType.Long !== item).map((key) => {
                                        return {
                                            label: key === ProposalContentType.Small ? 'Short' : convertPascalCaseToWords(key),
                                            value: key,
                                        };
                                    })}
                                    textField={"label"}
                                    valueField={"value"}
                                    placeholder="Proposal Type"
                                    onChange={(val) => onChange(val.value)}
                                    name={name}
                                    value={value}
                                />
                            )}
                        ></Controller>
                        <ErrorMessage>{errors.proposalContentType?.message}</ErrorMessage>
                    </div>
                    <div className="form-group font-weight-semibold mb-3 pb-1 col-12">
                        <label htmlFor="" className="font-md">
                            Reason<span className="text-danger">*</span>
                        </label>
                        <Controller
                            control={control}
                            name="reason"
                            defaultValue={createData?.sendProposalReason}
                            rules={{ required: "Reason is required" }}
                            render={({ onChange, value, name }) => (
                                <DropdownList
                                    data={reasons ?? []}
                                    placeholder="Reason"
                                    onChange={(val) => onChange(val.reason)}
                                    name={name}
                                    value={value}
                                    textField="reason"
                                    valueField="reason"
                                />
                            )}
                        ></Controller>
                        <ErrorMessage>{errors.reason?.message}</ErrorMessage>
                    </div>
                    {/* <div className="form-group font-weight-semibold mb-3 pb-1 col-12">
          <label htmlFor="" className="font-md">
          Floorplan & Furnishing Details
          </label>
          <Controller
            control={control}
            name="furnishingDetailsViewOption"
            defaultValue={createData?.furnishingDetailsViewOption || FurnishingDetailsViewOption.SinglePage}
            rules={{ required: "Floorplan & Furnishing Details" }}
            render={({ onChange, value, name }) => (
              <DropdownList
                data={[{
                    name: convertPascalCaseToWords(FurnishingDetailsViewOption.SinglePage), value: FurnishingDetailsViewOption.SinglePage
                },
                {
                  name: convertPascalCaseToWords(FurnishingDetailsViewOption.TwoColumn), value: FurnishingDetailsViewOption.TwoColumn
                },
                {
                  name: convertPascalCaseToWords(FurnishingDetailsViewOption.ThreeColumn), value: FurnishingDetailsViewOption.ThreeColumn
                }]}
                placeholder="Floorplan & Furnishing Details"
                onChange={(val) => onChange(val.value)}
                name={name}
                value={value}
                textField="name"
                valueField="value"
              />
            )}
          ></Controller>
          <ErrorMessage>{errors.reason?.message}</ErrorMessage>
        </div> */}
                    {/* {watch('furnishingDetailsViewOption') === FurnishingDetailsViewOption.SinglePage ? <div className="form-group font-weight-semibold mb-3 pb-1 col-12">
        <Controller
          control={control}
          name="excludeFloorPlan"
          defaultValue={createData?.excludeFloorPlan}
          rules={{ required: false }}
          render={({ onChange, value, name }) => (
            <>
              <input
                type="checkbox"
                className="form-check-input"
                id={name}
                checked={value}
                onChange={(e) => onChange(e.target.checked)}
              />
              <label htmlFor={name} className="font-md">
                Exclude Floor Plan
              </label>
            </>
          )}
        ></Controller>
        <ErrorMessage>{errors.excludeFloorPlan?.message}</ErrorMessage>
      </div> : null} */}
                    <h4 className="font-md pb-1 col-12 font-weight-semibold">
                        Comments
                    </h4>
                    <div className="form-group font-weight-semibold mb-0 pb-1 col-12">
                        <div>
                            <label htmlFor="" className="font-sm">
                                Tag From
                            </label>
                        </div>

                        <Controller
                            name="tagFrom"
                            control={control}
                            defaultValue={createData?.tagFrom || "activity"}
                            render={({ onChange, value }) => (
                                <ul className="click-tab bg-white d-flex list-unstyled d-inline-block">
                                    <li
                                        onClick={() => {
                                            onChange("activity");
                                            setValue("activity", "");
                                        }}
                                        className={`px-4 py-2 border font-md rounded-left cursor-pointer ${value === "activity"
                                            ? "border-primary text-primary"
                                            : "text-gray-900"
                                            }`}
                                    >
                                        Activity
                                    </li>
                                    <li
                                        onClick={() => {
                                            onChange("note");
                                            setValue("activity", "");
                                        }}
                                        className={`px-4 py-2 border  font-md rounded-right cursor-pointer ${value === "note"
                                            ? "border-primary border-left-primary"
                                            : "text-gray-900 border-left-0"
                                            }`}
                                    >
                                        Note
                                    </li>
                                </ul>
                            )}
                        />
                    </div>
                    {isUpdatingActivity ? (
                        <ContainerLoader height={200}></ContainerLoader>
                    ) : (
                        <>
                            <div className="form-group font-weight-semibold mb-3 pb-1 choose-filed col-12">
                                <label htmlFor="" className="font-sm">
                                    Choose
                                </label>
                                <Controller
                                    control={control}
                                    // rules={{ required: "Activity is required" }}
                                    name="activity"
                                    defaultValue={createData?.activityDetails}
                                    render={({ onChange, value, name }) => (
                                        <ActivityAutoCompleteInput
                                            defaultValue={value}
                                            placeholder={"Activity/Note"}
                                            onChange={(val) => {
                                                onChange(val);
                                            }}
                                            valueField={"name"}
                                            dataLoader={() => {
                                                return api.lead.getActivities(
                                                    requirementData?.leadId!
                                                );
                                            }}
                                            // disabled={updating}
                                            hideBlocked={true}
                                            type={watch("tagFrom")}
                                            leadDetails={requirementData?.leadDetails}
                                        />
                                    )}
                                />
                                <ErrorMessage>
                                    {(errors.activity as any)?.message}
                                </ErrorMessage>
                            </div>
                            {activity && (
                                <div className="form-group col-12">
                                    <div className="border p-3">
                                        <div className=" w-100 ">
                                            <div className="d-flex justify-content-between">
                                                <div
                                                    className="font-weight-bold text-truncate mb-1 font-sm"
                                                    dangerouslySetInnerHTML={{
                                                        __html: activity?.title || activity?.note,
                                                    }}
                                                ></div>
                                                <div className="text-right px-0 font-xs font-weight-semibold">
                                                    {activity?.type !== "note" && (
                                                        <>
                                                            <span
                                                                className="text-primary cursor-pointer"
                                                                onClick={() => {
                                                                    if (activity?.type !== "note") {
                                                                        onPressEdit(activity);
                                                                    }
                                                                }}
                                                            >
                                                                Edit{" "}
                                                            </span>{" "}
                                                            <span className="font-xs px-1 ">|</span>
                                                        </>
                                                    )}

                                                    <span
                                                        onClick={() => {
                                                            setValue("activity", undefined);
                                                        }}
                                                        className="cursor-pointer text-gray-700"
                                                    >
                                                        Remove
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="w-100 font-xs">
                                                <span className="text-muted font-weight-semibold">
                                                    {moment(activity?.createdAt).format(
                                                        "DD MMM YYYY hh:mm A"
                                                    )}
                                                </span>
                                                <span className="dot-separator d-inline-block bg-gray-400 rounded-circle mx-2"></span>
                                                <span className="text-muted font-weight-semibold pl-1">
                                                    {convertPascalCaseToWords(activity.type)}
                                                </span>
                                                <span className="dot-separator d-inline-block bg-gray-400 rounded-circle mx-2"></span>
                                                <span className="text-muted font-weight-semibold">
                                                    <span className="mr-1">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="14"
                                                            height="14"
                                                            viewBox="0 0 14 14"
                                                            fill="none"
                                                        >
                                                            <rect
                                                                width="14"
                                                                height="14"
                                                                rx="7"
                                                                fill={
                                                                    activity?.status === "planned"
                                                                        ? "#B8B8B8"
                                                                        : "#27AE60"
                                                                }
                                                            />
                                                            <path
                                                                d="M4 7.24219L5.9799 9.22209C6.058 9.30019 6.18464 9.30019 6.26274 9.22209L10.364 5.12087"
                                                                stroke="white"
                                                                stroke-linecap="round"
                                                            />
                                                        </svg>
                                                    </span>{" "}
                                                    {convertPascalCaseToWords(activity.status)}{" "}
                                                </span>
                                            </div>
                                            <div className="mt-3">
                                                <label className="font-xs font-weight-semibold">
                                                    Comments
                                                </label>
                                                <Controller
                                                    control={control}
                                                    name="comment"
                                                    defaultValue={createData?.sendProposalComment}
                                                    render={({ onChange, value, name }) => (
                                                        <textarea
                                                            className="w-100 border bg-gray-100 p-2 font-sm"
                                                            onChange={onChange}
                                                            value={value}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
